<template>
  <div class="fw-bold px-3 py-1 rule-header d-flex align-items-center">
    <div class="me-5">
      {{ trans(`subscription.validation_rules.rules.${rule.type}.name`) }}
    </div>
    <template v-if="rule.type === 'composite'">
      <RuleSelectOperator
        v-model="rule.operator"
        :rule-type="'composite'"
        @change="changeCompositeRuleType"
      />
    </template>
    <RuleRemove
      v-if="displayDelete"
      class="flex-grow-1"
      :rule-reference="ruleReference"
    />
  </div>
</template>

<script>
export default {
  name: 'RuleHeader',
  props: {
    ruleReference: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    displayDelete: {
      required: false,
      type: Boolean,
      default: true,
    },
    rule: {
      required: true,
      type: Object,
    },
  },
  methods: {
    changeCompositeRuleType (newValue) {
      this.$root.$emit('RuleOperatorChange', [this.ruleReference, newValue, undefined])
    },
  },
}
</script>

<style lang="scss" scoped>
.rule-header {
  background-color: rgba(0, 0, 0, 0.1);
}
.select-style{
  &:focus {
    border-color: #1b89ff;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 5px rgba(27, 137, 255, .5);
  }
}
</style>
